import { useQuery } from 'react-query';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';

export type NormalImageSizeSettings = {
    autoScale: boolean;
    size?: number | null;
    dpi?: number | null;
};

export type HighImageSizeSettings = {
    size: number;
    dpi: number;
};

export type OrderRowQuantityInfo = {
    orderRowId: number;
    expectedQuantity: number;
    isUploadable: number;
    productName: string;
};

export type PhotosInRow = {
    orderRowId: number;
    numberOfWantedPhotos: number;
    numberOfAddedPhotos: number;
};

export type ImageEditorPhotoStatus = {
    currentStatus: number;
    photographerIsEditor: boolean;
    normalImageSizeSettings?: NormalImageSizeSettings | null;
    highImageSizeSettings?: HighImageSizeSettings | null;
    orderRowQuantitiesInfo?: OrderRowQuantityInfo[] | null;
    photosInRows?: PhotosInRow[] | null;
    hasEditCustomerImages?: boolean;
    hasFlex?: boolean;
};

type PhotoStatusQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
    enabled?: boolean;
    refetchInterval?: number | false;
};

export let photoStatusQueryKey = 'image-editor-image-processing-page-get-photo-status';

export function usePhotoStatusQuery({
    orderId,
    user,
    enabled = true,
    refetchInterval = false
}: PhotoStatusQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading } = useQuery<ImageEditorPhotoStatus>(
        [photoStatusQueryKey, { orderId }],
        () => ImageProcessingApi.getPhotoStatus(orderId),
        {
            useErrorBoundary: true,
            enabled,
            refetchInterval,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'ImageEditorImageProcessingPage.Query.getPhotoStatus',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    return { data: data != null ? data : null, isLoading };
}
